import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import "./secondanimate.css"; // Ensure the CSS is correctly linked
import Pumps from "../../../Assets/image/pumps1-removebg-preview.png";

// Import animatedata from external file
import animatedata from "./animatedata.js";
import RevealBlurFX from "../../../components/Effect/RevealBlurFX.js";

const SecondAnimate = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [clonedData, setClonedData] = useState([...animatedata, animatedata[0]]); // Clone first slide for seamless loop
    const [transitioning, setTransitioning] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setTransitioning(true);
            setActiveIndex((prev) => prev + 1);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (activeIndex === animatedata.length) {
            setTimeout(() => {
                setTransitioning(false);
                setActiveIndex(0);
            }, 1000); // Delay reset to match transition duration
        }
    }, [activeIndex]);

    return (
        <div className="second_slider-container">
            <div
                className="second_slider"
                style={{
                    transform: `translateX(-${activeIndex * 100}%)`,
                    transition: transitioning ? "transform 1s ease-in-out" : "none",
                }}
            >
                {clonedData.map((data, index) => (
                    <div key={index} className={`second_slide ${activeIndex === index ? "active" : ""}`}>
                        {/* <RevealBlurFX> */}
                            <div style={{ objectFit: "cover" }}>
                                <img src={data.image} alt={data.title} />
                            </div>
                        {/* </RevealBlurFX> */}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SecondAnimate;
